module.exports = __webpack_public_path__ + "img/phase_b.4823c4df.svg";